import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/base/JsonLd";
import HeroSection from "./components/HeroSection";
import StatsBar from "./components/StatsBar";
import ValueProposition from "./components/ValueProposition";
import CategoryGrid from "./components/CategoryGrid";
import ComparisonSection from "./components/ComparisonSection";
import ArticlePreview from "./components/ArticlePreview";
import LatestArticles from "./components/LatestArticles";
import TestimonialSection from "./components/TestimonialSection";
import CTASection from "./components/CTASection";

const siteUrl = typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL
  ? import.meta.env.VITE_SITE_URL
  : 'https://cssspreadsheet.com';

const logoUrl = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'CSSSpreadsheet',
  url: siteUrl,
  logo: logoUrl,
  description: 'Agent shopping spreadsheet guides and comparison tools for CSSBuy, Kakobuy, Superbuy, and Oopbuy users.',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'CSSBuy Spreadsheet Guide 2026 - Agent Shopping System',
  description: 'Discover the CSSBuy Spreadsheet system for smart agent shopping. Complete guides, comparison tables, and category navigation for CSSBuy, Kakobuy, Superbuy, and Oopbuy spreadsheet systems.',
  url: siteUrl,
  primaryImageOfPage: {
    '@type': 'ImageObject',
    url: logoUrl,
  },
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd schema={organizationSchema} />
      <JsonLd schema={webPageSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <StatsBar />
        <ValueProposition />
        <CategoryGrid />
        <ComparisonSection />
        <ArticlePreview />
        <LatestArticles />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}